import { getAuthHeaders } from "@/api/auth"
import axios from "@/api/axiosAuthRequired.js"
import axiosAuthRequired from "@/api/axiosAuthRequired"
import moment from "moment"

export const getCurrentPayoutPeriod = async instaProToken => {
  try {
    const response = await axiosAuthRequired({
      method: "get",
      url:
        process.env.PROGUIDES_WEB_URL +
        "api/v2/instapro/user/coach/payouts/current",
      headers: {
        ...getAuthHeaders(),
        "X-INSTA-TOKEN": instaProToken,
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const getCoachingUptime = async (
  instaProToken,
  fromTimestamp,
  toTimestamp
) => {
  try {
    const response = await axiosAuthRequired({
      method: "get",
      url:
        process.env.PROGUIDES_WEB_URL +
        "api/v2/instapro/user/coach/activity/uptime?time_from=" +
        fromTimestamp +
        "&time_to=" +
        toTimestamp,
      headers: {
        ...getAuthHeaders(),
        "X-INSTA-TOKEN": instaProToken,
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const setCoachConnectivityStatus = async (instaProToken, status) => {
  try {
    await axios({
      method: "put",
      url: process.env.INSTAPRO_API_URL + "api/v1/coach/status",
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
      data: {
        set: status,
      },
    })
  } catch (e) {
    return Promise.reject(e)
  }
}

export const sendCoachPing = async instaProToken => {
  try {
    await axios({
      method: "put",
      url: process.env.INSTAPRO_API_URL + "api/v1/coach/ping",
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
    })
  } catch (e) {
    return Promise.reject(e)
  }
}

export const checkUsernameAvailability = async username => {
  try {
    const response = await axios({
      method: "post",
      url: process.env.INSTAPRO_API_URL + "api/v1/coach/username-valid",
      data: {
        username: username,
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const updateCoachProfile = async (instaProToken, coachProfileData) => {
  try {
    const response = await axios({
      method: "put",
      url: process.env.INSTAPRO_API_URL + "api/v1/coach",
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
      data: coachProfileData,
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const updateCoachGame = async (
  instaProToken,
  coachGameId,
  coachGameData
) => {
  try {
    await axios({
      method: "put",
      url: process.env.INSTAPRO_API_URL + "api/v1/coach/games/" + coachGameId,
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
      data: coachGameData,
    })
  } catch (e) {
    return Promise.reject(e)
  }
}

export const checkCoachAnnouncementViewed = async (instaProToken, aKey) => {
  try {
    return await axios({
      method: "get",
      url:
        process.env.INSTAPRO_API_URL + `api/v1/announcements/${aKey}/is-viewed`,
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
    })
  } catch (e) {
    return Promise.reject(e)
  }
}

export const viewCoachAnnouncement = async (instaProToken, aKey) => {
  try {
    return await axios({
      method: "post",
      url: process.env.INSTAPRO_API_URL + `api/v1/announcements/${aKey}/view`,
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
    })
  } catch (e) {
    return Promise.reject(e)
  }
}

export const getCoachingStats = async (instaproToken, gameId, period) => {
  try {
    const url = `${process.env.INSTAPRO_API_URL}api/v1/coach/retention`
    let from
    if (period === "DAILY") {
      from = moment()
        .subtract(6, "days")
        .format("YYYY-MM-DD")
    } else if (period === "WEEKLY") {
      from = moment()
        .subtract(6, "weeks")
        .format("YYYY-MM-DD")
    } else if (period === "MONTHLY") {
      from = moment()
        .subtract(1, "years")
        .format("YYYY-MM-DD")
    }
    const config = {
      params: {
        game_id: gameId,
        period,
        from,
      },
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/api/user/coaching/coachInfo.js